var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.handleScroll),expression:"handleScroll"}],staticClass:"fourth-box"},[_c('p',{staticClass:"fourth-box__text"},[_vm._v("夜の駅はまた違った雰囲気")])])}
var staticRenderFns = []

export { render, staticRenderFns }